/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Link, useLocation } from "react-router-dom";

const Footer: React.FC = () => {
    const location = useLocation();
    return (
        <div>
            <footer className="bg-secondaryColor text-white py-12">
                <div className="container flex flex-col">
                    <div className="w-full flex flex-col md:flex-row justify-between gap-4">
                        <img
                            className="w-[200px]"
                            src="assets/images/logo/logo-black.png"
                            alt="Workflow"
                        />
                        <ul className="list-reset flex items-center gap-4 md:gap-8 whitespace-nowrap flex-wrap">
                            <li><Link to="reservations" className={`text-primaryColor hover:text-primaryColorDark flex gap-2 items-center font-semibold ${location.pathname === "/reservations" ? "text-primaryColorDark" : ""}`}>Reservations</Link></li>
                            <li><Link to="/how-it-works" className={`text-primaryColor hover:text-primaryColorDark flex gap-2 items-center font-semibold ${location.pathname === "/how-it-works" ? "text-primaryColorDark" : ""}`}>How it works</Link></li>
                            <li><Link to="/vehicle" className={`text-primaryColor hover:text-primaryColorDark flex gap-2 items-center font-semibold ${location.pathname === "/vehicle" ? "text-primaryColorDark" : ""}`}>Vehicles</Link></li>
                            <li><Link to="/locations" className={`text-primaryColor hover:text-primaryColorDark flex gap-2 items-center font-semibold ${location.pathname === "/locations" ? "text-primaryColorDark" : ""}`}>Locations</Link></li>
                            <li><Link to="/contact-us" className={`text-primaryColor hover:text-primaryColorDark flex gap-2 items-center font-semibold ${location.pathname === "/contact-us" ? "text-primaryColorDark" : ""}`}>Contact Us</Link></li>

                        </ul>
                    </div>
                    <div className="h-px bg-primaryColor w-full my-5"></div>

                    <div className="w-full flex flex-col md:flex-row justify-between gap-4">
                        <div className="flex items-center text-[20px] gap-5 order-2 md:order-1">
                            <span className="text-primaryColor">
                                <i className="fa-brands fa-discord"></i>
                            </span>
                            <span className="text-primaryColor">
                                <i className="fa-brands fa-instagram"></i>
                            </span>
                            <span className="text-primaryColor">
                                <i className="fa-brands fa-facebook"></i>
                            </span>
                            <span className="text-primaryColor">
                                <i className="fa-brands fa-twitter"></i>
                            </span>
                        </div>
                        <a className="flex items-center gap-2 order-1"
                            href="mailto:info@logoipsum.com"
                        >
                            <span className="text-primaryColor font-semibold">
                                <i className="fa-regular fa-envelope"></i>
                            </span>
                            <span className="text-primaryColor font-semibold">info@logoipsum.com</span>
                        </a>
                    </div>
                </div>
            </footer>
            <div className="bg-primaryColor py-3">
                <div className="container text-secondaryColor capitalize text-base text-left">
                    <p className="text-sm">All Rights reserved.</p>
                </div>
            </div>
        </div>

    );
}

export default Footer;